var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18V2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V18C15 18.5523 14.5523 19 14 19H2C1.44772 19 1 18.5523 1 18Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5L3.98586 6.48586C3.99367 6.49367 4.00633 6.49367 4.01414 6.48586L5.5 5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5L3.98586 9.48586C3.99367 9.49367 4.00633 9.49367 4.01414 9.48586L5.5 8",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5L3.98586 12.4859C3.99367 12.4937 4.00633 12.4937 4.01414 12.4859L5.5 11",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5L3.98586 15.4859C3.99367 15.4937 4.00633 15.4937 4.01414 15.4859L5.5 14",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 10,
    width: 1,
    height: 4,
    fill: "#F5F6F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1724 8.17075C17.3629 7.95308 17.6977 7.94193 17.9023 8.14645L18.4849 8.72912C18.6711 8.91525 18.681 9.21381 18.5077 9.41191L17.609 10.439L16.3177 9.14763L17.1724 8.17075ZM15.6577 9.90188L11.651 14.481L12.9425 15.7725L16.9491 11.1933L15.6577 9.90188ZM12.25 16.4942L11.022 15.2662C11.0075 15.3133 11 15.3627 11 15.4128V16.5375H12.0462C12.1172 16.5375 12.1866 16.5224 12.25 16.4942ZM18.6094 7.43935C17.9958 6.82579 16.9912 6.85924 16.4198 7.51225L10.3711 14.4251C10.1319 14.6985 10 15.0495 10 15.4128V16.9375C10 17.2689 10.2686 17.5375 10.6 17.5375H12.0462C12.4788 17.5375 12.8903 17.3508 13.1751 17.0253L19.2603 10.0704C19.7803 9.47609 19.7504 8.5804 19.192 8.02201L18.6094 7.43935Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5H12.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H12.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11H11.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14H9.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.d130fb58.svg";
export { ForwardRef as ReactComponent };